import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import { jsonKeyToString } from "../../helpers/jsonToString";
import { mainDataValue } from "../../helpers/mainDataConvert";
import { objectToArray } from "../../helpers/objToArray";
import { Report } from "../../interfaces/intakes.reports";
import { globalStyles } from "./DocuPdf";
import { PDFCreatedBy } from "./PDFCreatedBy";

interface Props {
    data: Report
}

export const PDFMainData = ({ data }: Props) => {

    const { total_pallets, samples, format_gr,...rest } = data.mainData
    const mainData = [{
        key: 'Date of inspection', value: new Date(data?.date || new Date()).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        })
    }, ...objectToArray(rest)]

    // Dividir el array en dos mitades
    const mid = Math.ceil(mainData.length / 2);
    const leftCol = mainData.slice(0, mid);
    const rightCol = mainData.slice(mid);
    // // Dividir el array en dos mitades
    // const mid = Math.ceil(objectToArray(mainData).length / 2);
    // const leftCol = objectToArray(mainData).slice(0, mid);
    // const rightCol = objectToArray(mainData).slice(mid);

    return (
        <View style={{ marginBottom: 20 }}>

            <Text style={[globalStyles.h2, { marginBottom: 10 }]}>Batch Info</Text>

            <PDFCreatedBy data={data} />

            <View style={styles.grid}>
                {/* Columna izquierda */}
                <View style={styles.column}>
                    {leftCol.map((item, i) => (
                        <View key={i} style={globalStyles.flexRow}>
                            <Text style={[globalStyles.bold, styles.name]}>{jsonKeyToString(item.key)}: </Text>
                            <Text style={styles.sub}>{mainDataValue(item.key, item.value) || "--"}</Text>
                        </View>
                    ))}
                </View>

                {/* Columna derecha */}
                <View style={styles.column}>
                    {rightCol.map((item, i) => (
                        <View key={i} style={globalStyles.flexRow}>
                            <Text style={[globalStyles.bold, styles.name]}>{jsonKeyToString(item.key)}: </Text>
                            <Text style={styles.sub}>{mainDataValue(item.key, item.value) || "--"}</Text>
                        </View>
                    ))}
                </View>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({

    grid: {
        flexDirection: 'row',
        gap: 12,
    },
    column: {
        flex: 1,
        flexDirection: 'column',
        gap: 5,
    },

    name: {
        fontSize: 10,
    },
    sub: {
        fontSize: 10,
        color: '#6b7280',
    },
});